import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { generateRoutePath } from '@/src/routes';

import { SupplierAddress } from '../SupplierForm';

const url = `${PREFIX_URL}/quickbooks/:projectId/createVendor`;

export type CreateSupplierDTO = {
  projectId: string;
  params: {
    displayName: string;
    address: SupplierAddress;
    taxIdentifier: string;
    currency: string;
  };
};

const createSupplierResponseSchema = z.object({
  vendorId: z.string(),
  url: z.string(),
});

type CreateSupplierResponse = z.infer<typeof createSupplierResponseSchema>;

const createSupplier = ({
  projectId,
  params,
}: CreateSupplierDTO): Promise<CreateSupplierResponse> => {
  return axios.post(generateRoutePath(url, { projectId }), params);
};

export const useCreateSupplier = () => {
  return useMutation({
    mutationFn: (mutationsParams: CreateSupplierDTO) => createSupplier(mutationsParams),
    onSuccess: (response) => {
      // Will throw error if not matching
      createSupplierResponseSchema.parse(response);
    },
  });
};
